// ============================================================
// 계약 수명주기 정본 — 갱신(재계약) 유예 · 검수 판정 · 새 계약 유도 문구
// ============================================================
//
// 개선 9건 차수2d(26-08-04). 이 파일이 생긴 이유는 앞 차수 감사가 확정한 결함
// 두 건이 **같은 모양**이었기 때문이다:
//
//   · 유예 90일이 서버 두 파일에 각각 선언돼 있었다(집계 경계 · 원장 검수 경계).
//   · 새 계약 유도 문구가 서버 상수와 콘솔 리터럴 두 벌이었다.
//
// 두 경우 다 주석이 "같이 고칠 것"이라고 **부탁**만 했고 그물이 없었다 — 한쪽만
// 고쳐도 전 시험이 통과했다. 이 팀의 규칙은 '정본 1벌 + 드리프트 시험'이므로
// 부탁을 구조로 바꾼다. api·windows 가 둘 다 @bhops/shared 를 쓰므로 여기가 유일한
// 자리다.
//
// ⚠ 값을 고칠 때 알아야 할 것: 여기 있는 것은 **경계**이지 표시 문구가 아니다.
//   숫자를 바꾸면 재계약율(지표)과 '확인 필요' 판정(원장)이 **동시에** 움직인다 —
//   그것이 이 파일의 목적이다(둘이 갈리지 않게).
/**
 * 갱신 유예기간(일). 만기 후 이 기간 안에 갱신되면 '그 주기의 재계약'으로 센다.
 *
 * 두 곳이 같은 값을 봐야 한다:
 *   ① 재계약율 집계 — 분자 조건(`renewedAt <= previousEndDate + 유예`).
 *   ② 갱신 원장의 '확인 필요' 판정 — 만료까지 이 기간보다 더 남은 상태의 반납일
 *      연장은 갱신이 아니라 날짜 정정일 수 있다.
 * ①만 늘리면 "지표는 갱신으로 세는데 원장은 정정 의심으로 올리는" 구간이 생긴다.
 */
export const RENEWAL_GRACE_DAYS = 90;
/**
 * '확인 필요'로 올라온 갱신 원장 행을 사람이 확정한 결과.
 *
 * 원장은 append-only 라 행을 지우지 않는다(사실을 버리는 것이 이 팀이 닫은
 * '조용한 유실'이다). 대신 이 판정으로 **집계가 어떻게 셀지**가 갈린다:
 *   RENEWAL   — 진짜 갱신이다. 지표가 갱신으로 센다(모수·분자 양쪽).
 *   CORRECTION— 갱신이 아니라 날짜 정정이었다. 지표의 '갱신된 만기'에서 뺀다.
 *               그 계약의 만기는 정정된 반납일로 다시 도래한다(같은 만기를 두 번
 *               세지 않는다 — 재계약율 셈법의 근거).
 */
export const ContractRenewalReviewDecision = {
    RENEWAL: 'RENEWAL',
    CORRECTION: 'CORRECTION',
};
/** 화면 표기 — 버튼·목록이 같은 말을 쓰게 한다(코드 어휘를 사람에게 보이지 않는다). */
export const CONTRACT_RENEWAL_REVIEW_DECISION_LABEL = {
    RENEWAL: '갱신 맞음',
    CORRECTION: '날짜 정정',
};
/**
 * 배정이 끝난(INSTALLED) 계약에 로봇을 **더 요구하려는** 저장을 거부하는 문구.
 *
 * 서버 가드(409)와 화면의 사전 안내가 **같은 문장**이어야 한다. 화면은 저장 전에
 * 이 상황을 알려 주므로 보통 이 오류를 보지 않지만, API 를 직접 호출하는 경로
 * (스크립트·다른 화면)에는 화면 안내가 없다 — 그 경로의 조용한 유실을 막는 것이
 * 서버 가드의 목적이다. 두 문장이 갈리면 "사전 안내와 실제 오류가 다른 말을 하는"
 * 상태가 되어, 사전 안내를 믿을 수 없게 된다.
 */
export const INSTALLED_CONTRACT_LINE_ADD_MESSAGE = '이미 배정이 끝난 계약입니다 — 추가 판매는 새 계약으로 등록하세요.';
//# sourceMappingURL=contract-lifecycle.js.map